import Vue from 'vue';
import Vuex from 'vuex';
import analytics from './analytics';
import blog from './blog';
import custodian from './custodian';
import farm from './farm';
import investment from './investment';
import login from './login';
import notifications from './notifications';
import page from './page';
import profile from './profile';
import router from './router';
import view from './view';
import toaster from './toaster';
import system from './system';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    analytics,
    blog,
    custodian,
    farm,
    investment,
    login,
    notifications,
    page,
    profile,
    router,
    view,
    toaster,
    system,
  },
});

// Initial setup by actions
store.dispatch('notifications/setupNotification', null, { root: true });
store.dispatch('profile/setupNotification', null, { root: true });
store.dispatch('investment/setupNotification', null, { root: true });
store.dispatch('analytics/setupNotification', null, { root: true });
store.dispatch('system/setupNotification', null, { root: true });
store.dispatch('router/getSuperUserStatus', null, { root: true });

export default store;

export async function registerStoreModuleAsync(moduleName) {
  if (!store.hasModule(moduleName)) {
    const storeModule = await import(`./${moduleName}`);
    store.registerModule(moduleName, storeModule.default);
  }
}
